import { useEffect, useState } from "react";

export const getStorageUsername = (): string =>
  localStorage.getItem("username")?.trim() ?? "";

/**
 * Resolves the current login username from localStorage and keeps it in sync
 * when the user logs in or out (same pattern as useLookupData).
 */
export const useStorageUsername = (): string => {
  const [username, setUsername] = useState(getStorageUsername);

  useEffect(() => {
    const syncUsername = () => {
      setUsername(getStorageUsername());
    };

    window.addEventListener("userChanged", syncUsername);
    window.addEventListener("storage", syncUsername);

    return () => {
      window.removeEventListener("userChanged", syncUsername);
      window.removeEventListener("storage", syncUsername);
    };
  }, []);

  return username;
};
